import getUserList from "./getUserList";
import getUser from "./getUser";
import updateUser from "./updateUser";

export default { getUserList, getUser, updateUser };
